import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { demoPages, noMenuPages, multiCondosPages, doormanPages } from '../menu';
import Login from '../pages/presentation/auth/Login';
import TERMS from '../pages/presentation/auth/terms';

const ProtectedRoute = ({ children }) => {
	const token = localStorage.getItem('USER_TOKEN');
	if (!token || token === 'undefined' || token === 'null' || token === '') {
		localStorage.removeItem('USER_TOKEN');
		return <Navigate to='/' replace />;
	}

	return children;
};

ProtectedRoute.propTypes = {
	children: PropTypes.node.isRequired,
};

const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
	NO_AUTHORIZATE_PAGE: lazy(() => import('../pages/presentation/auth/noAuthorizatePage')),
	LOADERLAUNCH: lazy(() => import('../pages/presentation/auth/LoaderLaunch')),
	ADMIN: lazy(() => import('../pages/presentation/demo-pages/AdminRegisterPage')),
	PRICINGTABLE: lazy(() => import('../pages/presentation/pricing/PricingTablePage')),
	RECOVERYPASSWORD: lazy(() => import('../pages/presentation/auth/RecoverPassword')),
	RECOVERYPASSWORDSTEPTWO: lazy(() => import('../pages/presentation/auth/RecoverPasswordStepTwo')),
	INIVTE: lazy(() => import('../pages/presentation/auth/Invite')),
};

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/dashboard/DashboardPage')),
	RESIDENTREQUEST: lazy(() => import('../pages/presentation/demo-pages/RequestsPage')),
	RESIDENTS: lazy(() => import('../pages/presentation/demo-pages/ResidentsPage')),
	INVITATIONS: lazy(() => import('../pages/presentation/demo-pages/InvitationPage')),
	RESIDENTBALANCE: lazy(() => import('../pages/presentation/demo-pages/ResidentsBalancePage')),
	MOROSOS: lazy(() => import('../pages/common/CommonDefaulterEvents')),
	VEHICLE: lazy(() => import('../pages/vehicle/vehiclePage')),
	PETS: lazy(() => import('../pages/presentation/demo-pages/PetsPage')),
	COMITE: lazy(() => import('../pages/presentation/demo-pages/CommitteePage')),
	MARKET: lazy(() => import('../pages/presentation/demo-pages/MarketPage')),
	QUIZ: lazy(() => import('../pages/presentation/demo-pages/QuizPage')),
	DEVICES: lazy(() => import('../pages/presentation/demo-pages/DevicesPage')),
	DOORS: lazy(() => import('../pages/presentation/demo-pages/DoorsPage')),
	TIMERULES: lazy(() => import('../pages/presentation/demo-pages/TimeRulesPage')),
	STICKERS: lazy(() => import('../pages/presentation/demo-pages/StickersPage')),
	AREAS: lazy(() => import('../pages/presentation/demo-pages/AreaPage')),
	SUPPLIER: lazy(() => import('../pages/supplier/supplierPage')),
	GUESTS: lazy(() => import('../pages/presentation/demo-pages/GuestsPage')),
	BLACKLIST: lazy(() => import('../pages/presentation/demo-pages/BlackListPage')),
	EVENTSCALENDAR: lazy(() => import('../pages/event/eventCalendarPage')),
	ACTIVITIES: lazy(() => import('../pages/event/activitiesPage')),
	GOALS: lazy(() => import('../pages/goals/goalsPage')),
	COMMUNIQUE: lazy(() => import('../pages/goals/communiquePage')),
	EXTERNALSERVICES: lazy(() => import('../pages/common/CommonServicesEvents')),
	INGRESS: lazy(() => import('../pages/presentation/demo-pages/IncomePage')),
	AGREEMENTS: lazy(() => import('../pages/presentation/demo-pages/AgreementsPage')),
	EGRESS: lazy(() => import('../pages/finance/EgressPage')),
	BALANCE: lazy(() => import('../pages/presentation/demo-pages/BalancePage')),
	REPORTER: lazy(() => import('../pages/presentation/demo-pages/ReporterPage')),
	CHARGES: lazy(() => import('../pages/presentation/demo-pages/ChargePage')),
	ACCOUNTS: lazy(() => import('../pages/presentation/demo-pages/AccountsPage')),
	ADJUSTMENT: lazy(() => import('../pages/presentation/demo-pages/AdjustmentPage')),
	BUDGET: lazy(() => import('../pages/presentation/demo-pages/BudgetPage')),
	DOCUMENTS: lazy(() => import('../pages/presentation/demo-pages/DocumentsPage')),
	ACCOUNTSETUP: lazy(() => import('../pages/presentation/demo-pages/CondoPage')),
	ADMINISTRATOR: lazy(() => import('../pages/presentation/demo-pages/AdministratorPage')),
	REPORTS: lazy(() => import('../pages/presentation/demo-pages/ReportsPage')),
	WORKERDIRECTORY: lazy(() => import('../pages/presentation/demo-pages/WorkerDirectoryPage')),
	CLASSIFY: lazy(() => import('../pages/presentation/demo-pages/ClassifyPage')),
	PARKING: lazy(() => import('../pages/presentation/demo-pages/ParkingPage')),
	INVITEADMIN: lazy(() => import('../pages/presentation/demo-pages/InviteAdminPage')),
};

const MULTICONDO = {
	WORKSPACE: lazy(() => import('../pages/workspace/WorkSpacePage')),
};

const DOORMAN = {
	USER_PAGE: lazy(() => import('../pages/presentation/demo-pages/DoormanPage')),
};

const presentation = [
	/**
	 * Auth Page
	 */
	{
		path: noMenuPages.page404.path,
		element: <AUTH.PAGE_404 />,
		exact: true,
	},
	{
		path: noMenuPages.loaderLaunch.path,
		element: <AUTH.LOADERLAUNCH />,
		exact: true,
	},
	{
		path: noMenuPages.login.path,
		element: <Login />,
		exact: true,
	},
	{
		path: noMenuPages.invite.path,
		element: <AUTH.INIVTE />,
		exact: true,
	},
	{
		path: noMenuPages.signUp.path,
		element: <Login isSignUp />,
		exact: true,
	},
	{
		path: noMenuPages.pricingTable.path,
		element: <AUTH.PRICINGTABLE />,
		exact: true,
	},
	{
		path: noMenuPages.administrator.path,
		element: <AUTH.ADMIN />,
		exact: true,
	},
	{
		path: noMenuPages.recoverPasswordStepOne.path,
		element: <AUTH.RECOVERYPASSWORD />,
		exact: true,
	},
	{
		path: noMenuPages.recoverPasswordStepTwo.path,
		element: <AUTH.RECOVERYPASSWORDSTEPTWO />,
		exact: true,
	},
	{
		path: noMenuPages.termsAndConditionsApp.path,
		element: <TERMS />,
		exact: true,
	},

	/**
	 * Menu
	 */
	{
		path: demoPages.dashboard.path,
		element: (
			<ProtectedRoute>
				<LANDING.DASHBOARD />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.crmDashboard.subMenu.residentRequest.path,
		element: (
			<ProtectedRoute>
				<LANDING.RESIDENTREQUEST />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.crmDashboard.subMenu.resident.path,
		element: (
			<ProtectedRoute>
				<LANDING.RESIDENTS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.crmDashboard.subMenu.residentBalance.path,
		element: (
			<ProtectedRoute>
				<LANDING.RESIDENTBALANCE />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.crmDashboard.subMenu.morosos.path,
		element: (
			<ProtectedRoute>
				<LANDING.MOROSOS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.crmDashboard.subMenu.reports.path,
		element: (
			<ProtectedRoute>
				<LANDING.REPORTS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.crmDashboard.subMenu.invitations.path,
		element: (
			<ProtectedRoute>
				<LANDING.INVITATIONS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.crmDashboard.subMenu.vehicle.path,
		element: (
			<ProtectedRoute>
				<LANDING.VEHICLE />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.crmDashboard.subMenu.gridBoxed.path,
		element: (
			<ProtectedRoute>
				<LANDING.PETS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.crmDashboard.subMenu.reports.path,
		element: (
			<ProtectedRoute>
				<AUTH.NO_AUTHORIZATE_PAGE />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.summary.subMenu.comite.path,
		element: (
			<ProtectedRoute>
				<LANDING.COMITE />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.summary.subMenu.market.path,
		element: (
			<ProtectedRoute>
				<LANDING.MARKET />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.summary.subMenu.quiz.path,
		element: (
			<ProtectedRoute>
				<LANDING.QUIZ />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.summary.subMenu.areas.path,
		element: (
			<ProtectedRoute>
				<LANDING.AREAS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.summary.subMenu.supplier.path,
		element: (
			<ProtectedRoute>
				<LANDING.SUPPLIER />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.fluidSingle.subMenu.guests.path,
		element: (
			<ProtectedRoute>
				<LANDING.GUESTS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.fluidSingle.subMenu.blackList.path,
		element: (
			<ProtectedRoute>
				<LANDING.BLACKLIST />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.listBoxed.subMenu.calendar.path,
		element: (
			<ProtectedRoute>
				<LANDING.EVENTSCALENDAR />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.listBoxed.subMenu.activities.path,
		element: (
			<ProtectedRoute>
				<LANDING.ACTIVITIES />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.listFluid.path,
		element: (
			<ProtectedRoute>
				<AUTH.NO_AUTHORIZATE_PAGE />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.editModern.subMenu.goals.path,
		element: (
			<ProtectedRoute>
				<LANDING.GOALS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.editModern.subMenu.communique.path,
		element: (
			<ProtectedRoute>
				<LANDING.COMMUNIQUE />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.summary.subMenu.editBoxed.path,
		element: (
			<ProtectedRoute>
				<LANDING.EXTERNALSERVICES />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.editFluid.subMenu.ingress.path,
		element: (
			<ProtectedRoute>
				<LANDING.INGRESS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.editFluid.subMenu.egress.path,
		element: (
			<ProtectedRoute>
				<LANDING.EGRESS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.editFluid.subMenu.balance.path,
		element: (
			<ProtectedRoute>
				<LANDING.BALANCE />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.editFluid.subMenu.reporter.path,
		element: (
			<ProtectedRoute>
				<LANDING.REPORTER />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.crmDashboard.subMenu.agreemens.path,
		element: (
			<ProtectedRoute>
				<LANDING.AGREEMENTS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.editFluid.subMenu.charges.path,
		element: (
			<ProtectedRoute>
				<LANDING.CHARGES />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.editFluid.subMenu.accounts.path,
		element: (
			<ProtectedRoute>
				<LANDING.ACCOUNTS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.editFluid.subMenu.adjustment.path,
		element: (
			<ProtectedRoute>
				<LANDING.ADJUSTMENT />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.editFluid.subMenu.budget.path,
		element: (
			<ProtectedRoute>
				<LANDING.BUDGET />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.listFluid.subMenu.addDevices.path,
		element: (
			<ProtectedRoute>
				<LANDING.DEVICES />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.listFluid.subMenu.addDoors.path,
		element: (
			<ProtectedRoute>
				<LANDING.DOORS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.listFluid.subMenu.addTimeRules.path,
		element: (
			<ProtectedRoute>
				<LANDING.TIMERULES />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.listFluid.subMenu.addStickers.path,
		element: (
			<ProtectedRoute>
				<LANDING.STICKERS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.summary.subMenu.documents.path,
		element: (
			<ProtectedRoute>
				<LANDING.DOCUMENTS />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.summary.subMenu.condo.path,
		element: (
			<ProtectedRoute>
				<LANDING.ACCOUNTSETUP />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.editInModal.subMenu.administrators.path,
		element: (
			<ProtectedRoute>
				<LANDING.ADMINISTRATOR />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.crmDashboard.subMenu.workers.path,
		element: (
			<ProtectedRoute>
				<LANDING.WORKERDIRECTORY />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.crmDashboard.subMenu.classify.path,
		element: (
			<ProtectedRoute>
				<LANDING.CLASSIFY />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.summary.subMenu.parking.path,
		element: (
			<ProtectedRoute>
				<LANDING.PARKING />
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: demoPages.editInModal.subMenu.invite.path,
		element: (
			<ProtectedRoute>
				<LANDING.INVITEADMIN />
			</ProtectedRoute>
		),
		exact: true,
	},

	/**
	 * MultiCondosMenu
	 */
	{
		path: multiCondosPages.workSpace.path,
		element: (
			<ProtectedRoute>
				<MULTICONDO.WORKSPACE />,
			</ProtectedRoute>
		),
		exact: true,
	},
	{
		path: multiCondosPages.users.path,
		element: (
			<ProtectedRoute>
				<AUTH.PAGE_404 />,
			</ProtectedRoute>
		),
		exact: true,
	},

	/**
	 * DoormanMenu
	 */
	{
		path: doormanPages.doorman.subMenu.doormanUsers.path,
		element: (
			<ProtectedRoute>
				<DOORMAN.USER_PAGE />,
			</ProtectedRoute>
		),
		exact: true,
	},
];

const contents = [...presentation];

export default contents;
